import React from 'react';
import {
  RouteComponentProps,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import { NonAuthRoutes } from 'shared/Routes';
import { AppLayout } from 'layouts/AppLayout';
import { ApplicationState } from 'store';

interface Props {
  Component: React.FC<RouteComponentProps>;
  path: string | string[];
  exact?: boolean;
}

interface ParamTypes {
  orgId?: string;
  deptId?: string;
}

const AuthRoute = ({ Component, path, exact = false }: Props): JSX.Element => {
  const location = useLocation();

  const isLoggedIn = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.isLoggedIn,
  );

  const userAccess = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.userAccess,
  );

  const checkIfUserHasAccess = (
    organizationId?: string,
    departmentId?: string,
  ): boolean => {
    if (userAccess) {
      if (userAccess.isGlobalAdmin) {
        return true;
      }
      if (
        userAccess.organizations?.find(
          (organization) => organization.id === organizationId,
        )
      ) {
        return true;
      }
      if (!organizationId && userAccess.organizations?.length >= 1) {
        return true;
      }
      if (
        !!departmentId &&
        userAccess.departments.find(
          (departments) => departments.id === departmentId,
        )
      ) {
        return true;
      }
      if (departmentId === 'all') {
        return true;
      }
      if (!organizationId && !departmentId && userAccess.sawmills?.length > 0) {
        return true;
      }
    }
    return false;
  };

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps<ParamTypes>) => {
        const userHasAccess = checkIfUserHasAccess(
          props.match.params.orgId,
          props.match.params.deptId,
        );

        return isLoggedIn && userHasAccess ? (
          <AppLayout>
            <Component {...props} />
          </AppLayout>
        ) : isLoggedIn ? (
          <Redirect
            to={{
              pathname: NonAuthRoutes.Notauthorized,
              state: {
                requestedPath: path,
                referrer: location.pathname,
              },
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: NonAuthRoutes.Login,
              state: {
                requestedPath: path,
                referrer: location.pathname,
              },
            }}
          />
        );
      }}
    />
  );
};

export { AuthRoute };
